export default __webpack_public_path__ + "static/hero-879543027021b7d66727d89d6c631abc.webp";